module.exports = __webpack_public_path__ + "img/slider_galery_18.fdd5c59a.jpg";